import { FC, ReactNode, Suspense, lazy } from 'react';
import classnames from 'classnames';

import styles from './PdpSharedAuctionMessageContainer.scss';

const StarIcon = lazy(
    () => import(/* webpackChunkName: "StarIcon" */ 'dibs-icons/exports/StarFilled')
);

type Props = {
    text: ReactNode;
    isFullWidth?: boolean;
};

export const PdpSharedAuctionMessageContainer: FC<Props> = ({ text, isFullWidth }) => {
    return (
        <div className={classnames(styles.container, { [styles.isFullWidth]: isFullWidth })}>
            <div className={styles.content}>
                <span className={styles.iconWrapper}>
                    <Suspense fallback={null}>
                        <StarIcon className={styles.icon} />
                    </Suspense>
                </span>
                {text}
            </div>
        </div>
    );
};
